import { useEffect, useRef } from 'react';

// Quietly re-runs an existing fetch on an interval while the mounted screen is visible.
const REFRESH_MS = 25000;

export const useSilentRefresh = (refresh, active = true) => {
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => {
      if (document.visibilityState === 'visible') refreshRef.current();
    }, REFRESH_MS);
    return () => clearInterval(id);
  }, [active]);
};
